import { render, staticRenderFns } from "./custom-object.vue?vue&type=template&id=bd8e73f6&scoped=true&"
import script from "./custom-object.js?vue&type=script&lang=js&"
export * from "./custom-object.js?vue&type=script&lang=js&"
import style0 from "./custom-object.scss?vue&type=style&index=0&id=bd8e73f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8e73f6",
  null
  
)

component.options.__file = "custom-object.vue"
export default component.exports